export const getInitialFilters = stroeFilters => {
    const storedCategory = stroeFilters?.selectedCategory
    const storeFuelType = stroeFilters?.fuelType
    const storeMinCapacity = stroeFilters?.minCapacity
    const stroeMaxCapacity = stroeFilters?.maxCapacity

    return [
        {
            filterGrupName: 'Deals',
            checked: stroeFilters?.deals || false,
            hasFilters: false,
        },
        {
            filterGrupName: 'Class',
            filters: [
                {
                    filterName: 'All Classes',
                    checked: storedCategory === 'allClasses',
                },
                {
                    filterName: 'Aerial Lifts',
                    checked: storedCategory === 'aerialLifts',
                },
                {
                    filterName: 'Automations',
                    checked: storedCategory === 'automations',
                },
                {
                    filterName: 'Forklifts',
                    checked: storedCategory === 'forklifts',
                },
                {
                    filterName: 'Pallet Trucks',
                    checked: storedCategory === 'palletTrucks',
                },
                {
                    filterName: 'Warehouse Vehicles and Operated Machinery',
                    checked:
                        storedCategory ===
                        'warehouseVehiclesAndOperatedMachinery',
                },
                {
                    filterName: 'Warehouse Accessories',
                    checked: storedCategory === 'warehouseAccessories',
                },
                {
                    filterName: 'Legacy',
                    checked: storedCategory === 'legacy',
                },
            ],
        },
        {
            filterGrupName: 'Fuel Type',
            filters: [
                {
                    filterName: 'All',
                    checked: storeFuelType === 'All',
                },
                {
                    filterName: 'LPG',
                    checked: storeFuelType === 'LPG',
                },
                {
                    filterName: 'Diesel',
                    checked: storeFuelType === 'Diesel',
                },
                {
                    filterName: 'Electric',
                    checked: storeFuelType === 'Electric',
                },
            ],
        },
        {
            filterGrupName: 'Capacity',
            valueMin: storeMinCapacity || 3000,
            valueMax: stroeMaxCapacity || 10000,
        },
    ]
}

export const getSelectedField = (filters, field) => {
    const categoryGroup = filters?.find(i => i?.filterGrupName === field)
    const selectedCategory = categoryGroup?.filters?.find(
        i => i?.checked === true,
    )
    return selectedCategory
}

export const getDeals = filters => {
    const categoryGroup = filters?.find(i => i?.filterGrupName === 'Deals')
    return categoryGroup?.checked
}

export const getMinCapacity = filters => {
    const categoryGroup = filters?.find(i => i?.filterGrupName === 'Capacity')
    return categoryGroup?.valueMin
}

export const getMaxCapacity = filters => {
    const categoryGroup = filters?.find(i => i?.filterGrupName === 'Capacity')
    return categoryGroup?.valueMax
}
